(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[184],{

/***/ 8108:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-use",
      function () {
        return __webpack_require__(4029);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-banner-bg.dc0c0f4f.jpeg","height":575,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARECEiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJfrT4t9SUAAMLX/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6180);
/* harmony import */ var _public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1292);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4493);





function PageTitle(param) {
    var topComponent = param.topComponent, title = param.title, description = param.description, className = param.className;
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "", className),
        style: {
            backgroundImage: useHighContrast ? "unset" : "url(".concat(_public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                topComponent,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-4xl font-medium text-center", useHighContrast ? "text-inherit" : "text-white", description ? "mb-8" : null, topComponent ? "mt-4" : null),
                    children: title
                }),
                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-xl font-light text-center max-w-[760px]", useHighContrast ? "text-inherit" : "text-white"),
                    children: description
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_SEO; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./config/site.config.ts
var siteConfig = Object.freeze({
    title: "GoodFoodTalks",
    description: "GoodFoodTalks",
    twitterCreator: "@GoodFoodTalks"
});

;// CONCATENATED MODULE: ./components/utils/SEO.tsx



function SEO(param) {
    var pageTitle = param.title, description = param.description, socialImageSrc = param.socialImageSrc;
    var siteTitle = siteConfig.title, siteDescription = siteConfig.description, twitterCreator = siteConfig.twitterCreator;
    var title = "".concat(pageTitle, " | ").concat(siteTitle);
    var metaDescription = description !== null && description !== void 0 ? description : siteDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:creator",
                content: twitterCreator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: metaDescription
            }),
            socialImageSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: socialImageSrc
            }) : null
        ]
    });
}
/* harmony default export */ var utils_SEO = (SEO);


/***/ }),

/***/ 4029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_icons_im__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3990);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6180);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4493);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1284);
/* harmony import */ var _components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2555);
/* harmony import */ var _components_utils_SEO__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3618);








var HowToUse = function() {
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_2__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_utils_SEO__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                title: "How To Use",
                description: "How To Use"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                topComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_im__WEBPACK_IMPORTED_MODULE_6__/* .ImSpoonKnife */ .VcR, {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)("h-20 w-20", useHighContrast ? "text-black" : "text-primary-600"),
                    "aria-hidden": "true"
                }),
                title: "How to use"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)("py-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#f3f3e0]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "container space-y-14 font-light",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-xl font-bold",
                                    children: "How to make the most of GoodFoodTalks"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "To get the most out of Good Food Talks, you may want to take a moment to explore the accessibility features that come with your smartphone."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "list-disc list-inside",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "On the iPhone: go to Settings, General, Accessibility."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "On the Android: go to Applications, Settings, Accessibility."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: "What you see next will vary depending on the make and model of your phone, but we’d recommend trying out all of the different options, so that you can find a method of reading that works well for you."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Here are some general tips we hope you’ll find helpful."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-xl font-bold",
                                    children: "iPhone & ipad"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-base font-medium",
                                    children: "How to make the print bigger"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 1: put two fingers on the screen and draw them apart without lifting them off the screen. You can make the print as big or small as you want."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 2: turn the phone sideways, so that the screen is wide rather than tall (i.e. landscape). The print will get bigger automatically."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-base font-medium",
                                    children: "How to make the menu talk"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 1: go to Settings, General, Accessibility, VoiceOver. Set the toggle switch at the top to on. You’re now using VoiceOver, which reads everything on your screen to you. The controls are slightly different, but still very easy once you get used to them. Swipe left and right to navigate around your screen, and double tap to select an item or click on a link."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 2: go to Settings, General, Accessibility, Speak Selection. Set the toggle switch at the top to on. You’ll still be using your usual controls, but now, whenever you highlight text, you’ll have the option to hear your selection read out loud. Great for reading long descriptions of food."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-base font-medium",
                                    children: "How to make the print bigger"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 1: put two fingers on the screen and draw them apart without lifting them off the screen. You can make the print as big or small as you want."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 2: turn the phone sideways, so that the screen is wide rather than tall (i.e. landscape). On many of the newer Android models, the print will get bigger automatically."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)("space-y-4 border-b pb-14", useHighContrast ? "border-black" : null),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-xl font-bold",
                                    children: "Android"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-base font-medium",
                                    children: "How to make the menu talk"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 1: go to Applications, Settings, Accessibility, and enable TalkBack. (This will be either a checkbox or a toggle switch, depending on your phone.) TalkBack is the Android’s screen reader, which will speak everything you point to on your screen."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "Option 2: If your phone is running Android 4.1 or later, TalkBack will then ask whether you’d like to enable a feature called Explore By Touch. This feature, like VoiceOver on the iPhone, allows you to use your phone without looking at it at all. The screen controls are slightly different, but still very easy once you get used to them. Swipe left and right to navigate around your screen, and double tap to select an item or click on a link."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "space-y-4",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "For more detailed information about the accessibility features on your phone or tablet, visit:"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "http://www.apple.com/support/accessibility/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)(useHighContrast ? "link-contrast-underline" : "link-primary"),
                                            children: "http://www.apple.com/support/accessibility/"
                                        }),
                                        " ",
                                        "for iPhones"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: "https://support.google.com/accessibility/android/",
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)(useHighContrast ? "link-contrast-underline" : "link-primary"),
                                            children: "https://support.google.com/accessibility/android/"
                                        }),
                                        " ",
                                        "for Androids."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    children: [
                                        "Please feel free to",
                                        " ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                            prefetch: false,
                                            href: "/contact-us",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_7__/* .twMerge */ .m)(useHighContrast ? "link-contrast-underline" : "link-primary"),
                                                children: "contact us"
                                            })
                                        }),
                                        " ",
                                        "with any questions or feedback you may have."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: "We’d love to hear from you."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HowToUse);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,609,314,284,774,888,179], function() { return __webpack_exec__(8108); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);